import React from 'react';
import styled from 'styled-components';
import { ButtonType } from "../../Types";
import ThemeColors from "../../config/themeColors";

interface Props {
    altheight?: boolean;
    spacingL?: boolean;
    spacingR?: boolean;
    spacingT?: boolean;
    spacingB?: boolean;
    spacingBm?: boolean;
    full?: boolean;
    transparent?: boolean;
    difheight?: boolean;
    svg?: boolean;
    animationRotate?: boolean;
    spacingDeskB?: boolean;
    plus?: boolean;
    fontSize?: string;
    buttonType: ButtonType;
    onClick?: () => void;
    children: React.ReactNode;
    indicator?: string;
    color?: string;
    disabled?: boolean;
}

const DefaultButton = styled.button<Props>`
    disabled: ${props => props.disabled ? 'disabled' : null};
    cursor: pointer;
    position: relative;    
    background: ${ThemeColors.ftgGray};
    background: ${props => props.color}!important;
    color: ${ThemeColors.white};
    font-weight: 400;
    text-align: center;
    font-size: 1rem;
    line-height: 1.5;
    white-space: nowrap;
    vertical-align: middle;
    border: 0;
    border-radius: .35rem;    
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    padding: ${props => props.altheight ? '.6rem .8rem' : '.375rem .75rem'};
    margin-left: ${props => props.spacingL ? '1rem' : '0'};
    margin-right: ${props => props.spacingR ? '1rem' : '0'};
    margin-top: ${props => props.spacingT ? '1rem' : '0'};
    margin-bottom: ${props => props.spacingB ? '1rem' : '0'};
    width: ${props => props.full ? '100%' : 'auto'};
    opacity: ${props => props.transparent ? 0.50 : 1.0};
    ${props => props.transparent ? 'background: #a4a7aa!important;' : null};
    ${props => props.difheight ? 'align-self: center;' : null};
    &:disabled {
        opacity: .65;
    }
    &:focus {
        outline: none;
    }
    svg {
        transition: color 0.2s ease, transform .3s ease-in-out;
        margin-right: ${props => props.svg ? '0.4rem' : '0'};
    }
    svg:hover {
        color: ${ThemeColors.white};
    }
    @media (max-width: 480px) {
        margin: 0;
        margin-bottom: ${props => props.spacingB ? '0.5rem' : '0'};
        margin-bottom: ${props => props.spacingBm ? '0.5rem' : '0'};
    }
    transform: ${props => props.animationRotate ? 'rotate(0)' : null};
    &:hover > svg {
        transform: ${props => props.animationRotate ? 'rotate(180deg)' : null};
    }
    ${props => props.indicator ? 
        `:after {
            content: "${props.indicator}";
            position: absolute;
            display: block;
            width: 20px;
            height: 20px;
            background: #fff;
            font-size: 80%;
            border-radius: 50%;
            color: ${props.color};
            top: -7px;
            right: -9px;
            box-shadow: 0 0 0 1px ${props.color};
        }`
        : null};
`;

const Primary = styled(DefaultButton)`
    background: ${ThemeColors.ftgOrange};
    &:hover {
        background: ${ThemeColors.ftgOrangeHover};
    }    
`;

const Secundary = styled(DefaultButton)`
    background: ${ThemeColors.ftgBlue};
`;

const Delete = styled(DefaultButton)`
    background: ${ThemeColors.danger};
    &:hover {
        background: ${ThemeColors.dangerHover};
    }
`;

const Cancel = styled(DefaultButton)`
    background: ${ThemeColors.ftgGray};
    &:hover {
        background: ${ThemeColors.ftgGrayHover};
    }
`;

const Back = styled(Cancel)`
    svg {
        margin-right: 0.4rem;
    }
    margin-bottom: ${props => props.spacingB ? '1rem' : '0'};
    margin-bottom: ${props => props.spacingDeskB ? '0' : '1rem'};
`;


const Success = styled(DefaultButton)`
    background: ${ThemeColors.ftgGreen};
`;

const Icon = styled(Primary)`
    width: auto;
    border: 0;
    background: none;
    background-color: transparent;
    box-shadow: none;
    padding: 0;
    &:hover {
        background: none;
    }
    svg, svg:hover, svg:focus {
        color: ${props => props.plus ? ThemeColors.ftgOrange : ThemeColors.ftgGray};
        font-size: ${props => props.fontSize ?? '3rem'};
        display: flex;
    }
`;

const Invert = styled(Primary)`
    background: transparent;
    border: 1px solid ${ThemeColors.ftgOrange};
    color: ${ThemeColors.ftgOrange};
    &:hover {
        color: ${ThemeColors.white};
        border-color: ${ThemeColors.ftgOrangeHover};
    }
`;


const Button = (props: Props) => {

    let Button = <Cancel {...props}>{props.children}</Cancel>;

    switch (props.buttonType) {
        case ButtonType.Primary:
            Button = <Primary {...props}>{props.children}</Primary>;
            break;
        case ButtonType.Secondary:
            Button = <Secundary {...props}>{props.children}</Secundary>;
            break;
        case ButtonType.Delete:
            Button = <Delete {...props}>{props.children}</Delete>;
            break;
        case ButtonType.Back:
            Button = <Back {...props}>{props.children}</Back>;
            break;
        case ButtonType.Succes:
            Button = <Success {...props}>{props.children}</Success>;
            break;
        case ButtonType.Icon:
            Button = <Icon {...props}>{props.children}</Icon>;
            break;
        case ButtonType.Invert:
            Button = <Invert {...props}>{props.children}</Invert>;
            break;
        default:
            break;
    }

    return Button;

};

export default Button;